import React from "react";
import { Route, Switch } from "wouter";
import EditorPage from "./Editor/EditorPage";
import AuthenticationForm from "./Auth/Auth.jsx";
import ProfilePage from "./Profile/Profile.jsx";
import { useStore } from "./store";
import Home from "./Home/Home.jsx";
import ModGallery from "./Admin/ModGallery.jsx";
import Jobs from "./Admin/Jobs/Jobs.jsx";
import JobDetails from "./Admin/Jobs/JobDetails.jsx";
import Users from "./Admin/Users/Users.jsx";
import Contact from "./Contact.jsx";
import PaymentSuccess from "./Payment/Success.jsx";
import PaymentCancelled from "./Payment/Cancelled.jsx";
import PaymentPartial from "./Payment/Partial.jsx";
import { PlanPricingPage } from "./Payment/PlanPricingPage.jsx";
import SuperGallery from "./SuperGallery/SuperGallery.jsx";
import PluginManager from "./Plugins/PluginManager.jsx";
import TrainingDataSetsList from "./TrainingDatasets/List.jsx";
import TrainingDataSetEditor from "./TrainingDatasets/Edit.jsx";
import LoginLinkHandler from "./Auth/LoginLink.jsx";
import SuperGenerator from "./SuperGallery/Generator.jsx";
import StyleList from "./Styles/StyleList.jsx";
import AdminStyleList from "./Admin/Styles/StyleList.jsx";
import AdminStyleForm from "./Admin/Styles/StyleEdit.jsx";
import VideoPage from "./Editor/VideoPage.jsx";
import UserDetails from "./Admin/Users/UserDetails.jsx";
import { PlanPrepaid } from "./Payment/PlanPrepaid.jsx";
import AdminPluginList from "./Admin/PluginOptions/PluginList.jsx";
import AdminPluginOptionsList from "./Admin/PluginOptions/AdminPluginOptionsList.jsx";
import AdminPluginOptionEdit from "./Admin/PluginOptions/AdminPluginOptionEdit.jsx";

export default function AppRoutes() {
  const profile = useStore((state) => state.profile);

  const authRoutes = (
    <>
      <Route path="/auth" component={AuthenticationForm} />
      <Route path="/auth/login/:token" component={LoginLinkHandler} />
      <Route path="/contact" component={Contact} />
    </>
  );

  const upgradeRoutes = (
    <>
      <Route path="/profile" component={ProfilePage} />
      <Route path="/payment/plans" component={PlanPricingPage} />
      <Route path="/payment/prepaid" component={PlanPrepaid} />
      <Route path="/payment/completed" component={PaymentSuccess} />
      <Route path="/payment/cancelled" component={PaymentCancelled} />
      <Route path="/payment/partial" component={PaymentPartial} />
      <Route path="/styles" component={StyleList} />
      <Route path="/styles/:id" component={StyleList} />
    </>
  );

  const adminRoutes = (
    <>
      <Route path="/mod/gallery" component={ModGallery} />
      <Route path="/admin/jobs" component={Jobs} />
      <Route path="/admin/jobs/:id" component={JobDetails} />
      <Route path="/admin/users" component={Users} />
      <Route path="/admin/users/:id" component={UserDetails} />
      <Route path="/admin/styles" component={AdminStyleList} />
      <Route path="/admin/styles/new" component={AdminStyleForm} />
      <Route path="/admin/styles/:id" component={AdminStyleForm} />
      <Route path="/admin/plugins" component={AdminPluginList} />
      <Route
        path="/admin/plugins/:id/options"
        component={AdminPluginOptionsList}
      />
      <Route
        path="/admin/plugins/:pluginId/options/:optionId"
        component={AdminPluginOptionEdit}
      />
      {/* <Route path="/three" component={ThreeComponent} /> */}
    </>
  );

  const paidUserRoutes = (
    <>
      <Route path="/gallery" component={SuperGallery} />
      <Route path="/generate" component={SuperGenerator} />
      <Route path="/editor" component={EditorPage} />
      <Route path="/video" component={VideoPage} />
      <Route path="/plugins" component={PluginManager} />
      <Route path="/training-datasets" component={TrainingDataSetsList} />
      <Route path="/training-datasets/:id" component={TrainingDataSetEditor} />
    </>
  );

  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/home" component={Home} />
      {authRoutes}
      {upgradeRoutes}
      {paidUserRoutes}
      {profile?.role === "Admin" && adminRoutes}
      <Route>404, Not Found!</Route>
    </Switch>
  );
}
